import axios from '../utils/request'

const PriceRulesInfo = () => {
  return axios.get('GetPriceRulesInfo', { })
}

const PriceRulesList = (ClassificationID) => {
  return axios.get('GetPriceRulesList?ClassificationID=' + ClassificationID, { })
}

const PriceRulesSelectionData = (ClassificationID) => {
  return axios.get('PriceRulesSelectionData?ClassificationID=' + ClassificationID, { })
}

const PriceData = (ID) => {
  return axios.get('GetPriceData?Price_rules_ID=' + ID, { })
}

const PriceModalSelectionData = (ID) => {
  return axios.get('GetPriceModalSelectionData?Price_rules_ID=' + ID, { })
}

const DeletePriceModalData = (ID) => {
  return axios.get('DeletePriceModalData?dispose_id=' + ID, { })
}

const GetPaperCoreListApi = () => {
  return axios.get('GetPaperCoreList', { })
}

const GetBackstagePETRulesApi = (id, CurrentPage, pageSize) => {
  return axios.get('GetBackstagePETRules?id=' + id + '&CurrentPage=' + CurrentPage + '&pageSize=' + pageSize, { })
}

const GetTaxPointListApi = (ClassificationID, CurrentPage, pageSize) => {
  return axios.get('GetTaxPointList?ClassificationID=' + ClassificationID + '&CurrentPage=' + CurrentPage + '&pageSize=' + pageSize, { })
}

const GetBillingTypeListApi = () => {
  return axios.get('GetBillingTypeList', { })
}

const GetBatchData = (PriceRulesID) => {
  return axios.get('GetBatchData?PriceRulesID=' + PriceRulesID, { })
}

const GetChangePriceLog = (ClassificationID, CurrentPage, pageSize) => {
  return axios.get('GetChangePriceLog?ClassificationID=' + ClassificationID + '&CurrentPage=' + CurrentPage + '&pageSize=' + pageSize, { })
}

const ChangePriceRulesMainInfo = (loginInfo) => {
  return axios.post('ChangeMainPriceRules', {
    ...loginInfo
  })
}

const ChangePriceRulesDetailInfo = (loginInfo) => {
  return axios.post('ChangeDetailPriceRules', {
    ...loginInfo
  })
}

const InsertPriceModalData = (loginInfo) => {
  return axios.post('InsertPriceModalData', {
    ...loginInfo
  })
}

const GetFreightDataApi = (loginInfo) => {
  return axios.post('GetFreightData', {
    ...loginInfo
  })
}

const ChangeFreightData = (loginInfo) => {
  return axios.post('ChangeFreightData', {
    ...loginInfo
  })
}

const ChangeBackstagePETRules = (loginInfo) => {
  return axios.post('ChangeBackstagePETRules', {
    ...loginInfo
  })
}

const ChangeBillingTypeData = (loginInfo) => {
  return axios.post('ChangeBillingTypeData', {
    ...loginInfo
  })
}

const ChangeBatchData = (loginInfo) => {
  return axios.post('ChangeBatchData', {
    ...loginInfo
  })
}

export {
  PriceRulesInfo,
  ChangePriceRulesMainInfo,
  ChangePriceRulesDetailInfo,
  PriceRulesSelectionData,
  PriceRulesList,
  PriceData,
  PriceModalSelectionData,
  InsertPriceModalData,
  DeletePriceModalData,
  GetFreightDataApi,
  ChangeFreightData,
  GetPaperCoreListApi,
  GetBackstagePETRulesApi,
  ChangeBackstagePETRules,
  GetTaxPointListApi,
  GetBillingTypeListApi,
  ChangeBillingTypeData,
  GetBatchData,
  ChangeBatchData,
  GetChangePriceLog
}
